import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgSms = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M22 2H2a1 1 0 0 0-1 1v15l.007.117A1 1 0 0 0 2 19h3.5v1.5l.006.115a1 1 0 0 0 1.441.78L11.735 19H22a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-1 2v13h-9.5l-.116.007a1 1 0 0 0-.331.099L7.5 18.88V18l-.007-.117A1 1 0 0 0 6.5 17H3V4h18Z" />
      <path d="M7 8.75a1 1 0 0 1 .993.883L8 9.75v1.5a1 1 0 0 1-1.993.117L6 11.25v-1.5a1 1 0 0 1 1-1ZM12 8.75a1 1 0 0 1 .993.883L13 9.75v1.5a1 1 0 0 1-1.993.117L11 11.25v-1.5a1 1 0 0 1 1-1ZM17 8.75a1 1 0 0 1 .993.883L18 9.75v1.5a1 1 0 0 1-1.993.117L16 11.25v-1.5a1 1 0 0 1 1-1Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgSms)
const Memo = memo(ForwardRef)
export default Memo
